import { OrgId } from "@hex/common";

import { Routes } from "../../route/routes";

interface StartSsoLoginArgs {
  authQueryParams: Record<string, string>;
  embedded: boolean;
  onComplete: () => void;
  onSubmit: () => void;
  orgId: OrgId;
}

export function startSsoLogin({
  authQueryParams,
  embedded,
  onComplete,
  onSubmit,
  orgId,
}: StartSsoLoginArgs): void {
  onSubmit();

  const ssoUrl = Routes.SSO_AUTH.getUrl({
    orgId,
    queryParams: authQueryParams,
  });

  if (embedded) {
    window.open(ssoUrl, "_blank");
    onComplete();
  } else {
    window.location.href = ssoUrl;
  }
}
